import React from 'react'

export function ProntuarioFamiliarView() {
  return <div>Hello World!</div>
}
